import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  AuditOutlined,
  UserOutlined,
  SoundOutlined,
  ScheduleOutlined,
  SafetyCertificateOutlined,
  FileSearchOutlined,
  HistoryOutlined,
  DashboardOutlined,
  RobotOutlined,
  ContainerOutlined,
  NotificationOutlined,
} from "@ant-design/icons";
import { getMenuById, getAllAction } from "../helpers/helper";
import { useUserDetails } from "../context/UserDetailContext";
import { useTranslation } from "react-i18next";

const Navdata = () => {
  const history = useHistory();
  const { t } = useTranslation();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isDepartment, setIsDepartment] = useState(false);
  const [isEmployee, setIsEmployee] = useState(false);
  const [isSingleApply, setIsSingleApply] = useState(false);
  const [isShift, setIsShift] = useState(false);
  const [isDecentralization, setIsDecentralization] = useState(false);
  const [isHistory, setIsHistory] = useState(false);
  const [isActionHistory, setIsActionHistory] = useState(false);
  const [isBot, setIsBot] = useState(false);
  const [isRules, setIsRules] = useState(false);
  const [isNotify, setIsNotify] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");
  const [listActionGroup, setListActionGroup] = useState([]);
  const [roleUser, setRoleUser] = useState("");
  const [listAllAction, setListAllAction] = useState([]);

  const { userDetails } = useUserDetails();

  const { userInfo } = useSelector((state) => ({
    userInfo: state.Login.userInfo,
  }));

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems?.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const getRoleFromSessionStorage = () => {
    if (userDetails && userDetails.role) {
      return userDetails.role;
    } else {
      return null;
    }
  };

  const checkVisibleMenu = (param) => {
    if (roleUser?.roleName === "SuperAdmin") {
      return true;
    }
    let roleUserAction = true;
    let checkVisible = false;
    let strPaging = "";
    switch (param) {
      case "dashboard-employee":
        strPaging = "dashboard-employee";
        break;
      case "dashboard-application":
        strPaging = "dashboard-application";
        break;
      case "dashboard-history":
        strPaging = "dashboard-history";
        break;
      case "history":
        strPaging = `getPagingHistories`;
        checkVisible = listActionGroup.some((str) => str === "history");
        break;
      case "duplicate-ip":
        strPaging = `getSameIp`;
        checkVisible = listActionGroup.some((str) => str === "history");
        break;
      case "duplicate-fp":
        strPaging = `getSameFp`;
        checkVisible = listActionGroup.some((str) => str === "history");
        break;
      case "duplicate-ip-collab":
        strPaging = `getSameIp`;
        checkVisible = listActionGroup.some((str) => str === "history");
        break;
      case "duplicate-fp-collab":
        strPaging = `getSameFp`;
        checkVisible = listActionGroup.some((str) => str === "history");
        break;
      case "duplicate-ip-fp":
        strPaging = `getSameFp`;
        checkVisible = listActionGroup.some((str) => str === "history");
        break;
      case "duplicate-ip-old":
        strPaging = `getSameIp`;
        checkVisible = listActionGroup.some((str) => str === "history");
        break;
      case "duplicate-fp-old":
        strPaging = `getSameFp`;
        checkVisible = listActionGroup.some((str) => str === "history");
        break;
      case "group-management":
        strPaging = `getGroupManagementPage`;
        checkVisible = listActionGroup.some((str) => str === "department");
        break;
      case "company-management":
        strPaging = `getCompanyManagementPage`;
        checkVisible = listActionGroup.some((str) => str === "company");
        break;
      case "action-history":
        strPaging = `getActionHistoryManagementPage`;
        checkVisible = listActionGroup.some((str) => str === "actionHistory");
        break;
      case "bot-chat":
        strPaging = `getAllGroupAndBot`;
        checkVisible = listActionGroup.some((str) => str === "groupAndBot");
        break;
      case "message":
        strPaging = `getMessage`;
        checkVisible = listActionGroup.some((str) => str === "message");
        break;
      case "rules":
        strPaging = `getAllRules`;
        checkVisible = listActionGroup.some((str) => str === "dashboard");
        break;
      case "notify":
        strPaging = `getPagingNotify`;
        checkVisible = listActionGroup.some((str) => str === "dashboard");
        break;
      default:
        strPaging = `get${capitalizeFirstLetter(param)}ManagementPage`;
        checkVisible = listActionGroup.some((str) => str === param);
    }

    roleUserAction = listAllAction.some(
      (item) => item.actionName === strPaging
    );

    return checkVisible && roleUserAction;
  };

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Department") {
      setIsDepartment(false);
    }
    if (iscurrentState !== "Employee") {
      setIsEmployee(false);
    }
    if (iscurrentState !== "SingleApply") {
      setIsSingleApply(false);
    }
    if (iscurrentState !== "Shift") {
      setIsShift(false);
    }
    if (iscurrentState !== "Decentralization") {
      setIsDecentralization(false);
    }
    if (iscurrentState !== "History") {
      setIsHistory(false);
    }
    if (iscurrentState !== "ActionHistory") {
      setIsActionHistory(false);
    }
    if (iscurrentState !== "bot-chat") {
      setIsBot(false);
    }
    if (iscurrentState !== "rules") {
      setIsRules(false);
    }
  }, [history, iscurrentState, isDashboard]);

  useEffect(() => {
    const getMenuByRoleId = async () => {
      try {
        const role = getRoleFromSessionStorage();
        if (role) {
          const { _id, actions } = role;
          setRoleUser(role);
          let profileUser = userInfo;
          if (!userInfo) {
            profileUser = await getMenuById(_id);
          }
          if (profileUser.actionGroups) {
            setListActionGroup(profileUser.actionGroups);
          }

          let listAllAction = profileUser?.allActions;
          if (!userInfo) {
            listAllAction = await getAllAction();
          }
          const listAllActionByRole = [];
          listAllAction?.forEach((item) => {
            const checkAction = actions?.includes(item._id);
            if (checkAction) {
              listAllActionByRole.push({
                _id: item._id,
                actionName: item.actionName,
              });
            }
          });
          setListAllAction(listAllActionByRole);
        }
      } catch (error) {
        console.log(error, "error");
      }
    };
    getMenuByRoleId();
  }, [userDetails]);

  const menuItems = [
    {
      label: "Quản lý",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: t("menuTotal"),
      icon: <DashboardOutlined />,
      link: "/dashboard",
      stateVariables: isDashboard,
      visible: true,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "dashboardEmployee",
          label: t("userChart"),
          link: "/dashboard-employee",
          parentId: "dashboard",
          actionGroup: "dashboard",
          visible: true,
        },
        {
          id: "dashboardApplication",
          label: t("applyChart"),
          link: "/dashboard-application",
          parentId: "dashboard",
          actionGroup: "dashboard",
          visible: true,
        },
        {
          id: "dashboardHistory",
          label: t("historyChart"),
          link: "/dashboard-history",
          parentId: "dashboard",
          actionGroup: "dashboard",
          visible: true,
        },
      ],
    },
    {
      id: "department",
      label: t("menuManagerCompany"),
      icon: <AuditOutlined />,
      link: "/department",
      stateVariables: isDepartment,
      visible:
        checkVisibleMenu("department") ||
        checkVisibleMenu("group-management") ||
        checkVisibleMenu("company-management"),
      click: function (e) {
        e.preventDefault();
        setIsDepartment(!isDepartment);
        setIscurrentState("Department");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "companyManagement",
          label: t("managerCompany"),
          link: "/company-management",
          parentId: "department",
          actionGroup: "department",
          visible: checkVisibleMenu("company-management"),
        },
        {
          id: "departmentManagement",
          label: t("managerDepartment"),
          link: "/department-management",
          parentId: "department",
          actionGroup: "department",
          visible: checkVisibleMenu("department"),
        },
        {
          id: "groupManagement",
          label: t("managerGroup"),
          link: "/group-management",
          parentId: "department",
          actionGroup: "department",
          visible: checkVisibleMenu("group-management"),
        },
      ],
    },
    {
      id: "employee",
      label: t("menuManagerUser"),
      icon: <UserOutlined />,
      link: "/employee",
      stateVariables: isEmployee,
      visible: checkVisibleMenu("user"),
      click: function (e) {
        e.preventDefault();
        setIsEmployee(!isEmployee);
        setIscurrentState("Employee");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "employeeManager",
          label: t("menuManagerUser"),
          link: "/employee-manager",
          parentId: "employee",
          actionGroup: "user",
          visible: true,
        },
      ],
    },
    {
      id: "singleApply",
      label: t("menuManagerApply"),
      icon: <ScheduleOutlined />,
      link: "/application",
      stateVariables: isSingleApply,
      visible: checkVisibleMenu("application"),
      click: function (e) {
        e.preventDefault();
        setIsSingleApply(!isSingleApply);
        setIscurrentState("SingleApply");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "application",
          label: t("menuManagerApply"),
          link: "/application-management",
          parentId: "singleApply",
          actionGroup: "application",
          visible: true,
        },
      ],
    },
    {
      id: "attendanceShift",
      label: t("menuManagerAttendance"),
      icon: <SoundOutlined />,
      link: "/attendance-shift",
      stateVariables: isShift,
      visible: checkVisibleMenu("shift"),
      click: function (e) {
        e.preventDefault();
        setIsShift(!isShift);
        setIscurrentState("Shift");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "shift",
          label: t("menuManagerAttendance"),
          link: "/shift",
          parentId: "attendanceShift",
          actionGroup: "shift",
          visible: true,
        },
      ],
    },
    {
      id: "decentralization",
      label: t("menuRole"),
      icon: <SafetyCertificateOutlined />,
      link: "/decentralization",
      stateVariables: isDecentralization,
      visible: checkVisibleMenu("role"),
      click: function (e) {
        e.preventDefault();
        setIsDecentralization(!isDecentralization);
        setIscurrentState("Decentralization");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "action",
          label: "Hành động",
          link: "/action",
          parentId: "action",
          actionGroup: "action",
          visible: false,
        },
        {
          id: "role",
          label: t("role"),
          link: "/role",
          parentId: "role",
          actionGroup: "role",
          visible: checkVisibleMenu("role"),
        },
      ],
    },
    {
      id: "loginHistory",
      label: t("menuManagerLogin"),
      icon: <FileSearchOutlined />,
      link: "/login-history",
      stateVariables: isHistory,
      visible:
        checkVisibleMenu("history") ||
        checkVisibleMenu("duplicate-ip") ||
        checkVisibleMenu("duplicate-fp") ||
        checkVisibleMenu("duplicate-ip-collab") ||
        checkVisibleMenu("duplicate-fp-collab") ||
        checkVisibleMenu("duplicate-ip-fp"),
      click: function (e) {
        e.preventDefault();
        setIsHistory(!isHistory);
        setIscurrentState("History");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "history",
          label: t("historyLogin"),
          link: "/history",
          parentId: "loginHistory",
          actionGroup: "history",
          visible: checkVisibleMenu("history"),
        },
        {
          id: "duplicate-ip",
          label: t("duplicateIp"),
          link: "/duplicate-ip",
          parentId: "loginHistory",
          actionGroup: "history",
          visible: checkVisibleMenu("duplicate-ip"),
        },
        {
          id: "duplicate-fp",
          label: t("duplicateFp"),
          link: "/duplicate-fp",
          parentId: "loginHistory",
          actionGroup: "history",
          visible: checkVisibleMenu("duplicate-fp"),
        },
        {
          id: "duplicate-ip",
          label: t("duplicateIpCollab"),
          link: "/duplicate-ip-collab",
          parentId: "loginHistory",
          actionGroup: "history",
          visible: checkVisibleMenu("duplicate-ip"),
        },
        {
          id: "duplicate-fp",
          label: t("duplioateFpCollab"),
          link: "/duplicate-fp-collab",
          parentId: "loginHistory",
          actionGroup: "history",
          visible: checkVisibleMenu("duplicate-fp"),
        },
        {
          id: "duplicate-ip-fp",
          label: t("duplicateIpAndFp"),
          link: "/duplicate-ip-fp",
          parentId: "loginHistory",
          actionGroup: "history",
          visible: checkVisibleMenu("duplicate-ip-fp"),
        },
      ],
    },
    {
      id: "actionHistory",
      label: t("managerAction"),
      icon: <HistoryOutlined />,
      link: "/action-history",
      stateVariables: isActionHistory,
      visible: checkVisibleMenu("action-history"),
      click: function (e) {
        e.preventDefault();
        setIsActionHistory(!isActionHistory);
        setIscurrentState("ActionHistory");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "actionHistory-childrent",
          label: t("actionHistory"),
          link: "/action-history",
          parentId: "actionHistory",
          actionGroup: "action-history",
          visible: checkVisibleMenu("action-history"),
        },
      ],
    },
    {
      id: "bot-chat",
      label: t("managerNotification"),
      icon: <RobotOutlined />,
      link: "/bot-chat",
      stateVariables: isBot,
      visible: checkVisibleMenu("bot-chat"),
      click: function (e) {
        e.preventDefault();
        setIsBot(!isBot);
        setIscurrentState("bot-chat");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "bot-chat-childrent",
          label: t("botNotification"),
          link: "/bot",
          parentId: "bot-chat",
          actionGroup: "bot-chat",
          visible: checkVisibleMenu("bot-chat"),
        },
        {
          id: "bot-chat-childrent",
          label: t("messenger"),
          link: "/message",
          parentId: "bot-chat",
          actionGroup: "bot-chat",
          visible: checkVisibleMenu("message"),
        },
      ],
    },
    {
      id: "rule",
      label: t("rulesManager"),
      icon: <ContainerOutlined />,
      link: "/rules",
      stateVariables: isRules,
      visible: checkVisibleMenu("rules"),
      click: function (e) {
        e.preventDefault();
        setIsRules(!isRules);
        setIscurrentState("rules");
        updateIconSidebar(e);
      },
    },
    {
      id: "notify",
      label: t("notifyManager"),
      icon: <NotificationOutlined />,
      link: "/notify",
      stateVariables: isNotify,
      visible: checkVisibleMenu("notify"),
      click: function (e) {
        e.preventDefault();
        setIsNotify(!setIsNotify);
        setIscurrentState("notify");
        updateIconSidebar(e);
      },
    },
  ];

  return <>{menuItems}</>;
};
export default Navdata;
